export default "__VITE_ASSET__bgC$fx_q__"